<template>
  <div class="unpackInventory-list">
    <QueryFrame

      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :disablePage="disablePage"
      :count="count"
      :current="page"
    >
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
          <!-- <label>商品搜索:</label>
          <lk-input class="item" v-model="query.nameMix" clearable placeholder="可按商品名、通用名、编码、助记码搜索" /> -->
        </div>
        <div class="queryItem">
          <label>批号:</label>
          <lk-input class="item" v-model="query.batchCode" clearable placeholder="请输入" />
        </div>
        <div class="queryItem">
          <label>生产企业:</label>
          <lk-input class="item" v-model="query.producer" clearable placeholder="生产厂家" />
        </div>
        <div class="queryItem">
            <label>拆零时间段:</label>
            <timeStampDatePicker type='daterange' placeholder="请选择" class="item" v-model.trim='query.unpackTimeRange' ></timeStampDatePicker>
        </div>
        <div class="queryItem">
            <label>是否有库存:</label>
            <lk-select class="item" clearable v-model='query.hasGoods'>
                <lk-option v-for="item in statuslist" :key="item.value" :value='item.value*1'>{{item.label}}</lk-option>
            </lk-select>
        </div>
        <div class="queryItem" v-if="roleType!==2">
            <label style="width:">门店:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="search-btn" @click="handleSearch">查询</lk-button>
          <lk-button @click="clear">重置</lk-button>
        </div>
      </div>
      <div slot="table">
        <div class='mb8'>
<DownloadButton @on-click='handleExport'></DownloadButton>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import unpack from '../../services/unpack';
import utils from '../../libs/utils';

import DownloadButton from '../../components/download/DownloadButton.vue';

export default {
  name: 'unpackInventory',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, DownloadButton,
  },
  data() {
    return {
      query: {
        unpackTimeRange: [],
        hasGoods: null,
      },
      statuslist: [
        {
          value: 1,
          label: '是',
        },
        {
          value: 2,
          label: '否',
        },
      ],
      columns: [
        {
          title: '序号', key: 'index', minWidth: 116, tooltip: true, fixed: 'left', type: 'index',
        },
        {
          title: '通用名', key: 'approvedDrugName', minWidth: 116, tooltip: true,
        },
        {
          title: '商品编码', key: 'drugSerialCode', minWidth: 116, tooltip: true,
        },
        {
          title: '规格', key: 'spec', minWidth: 116, tooltip: true,
        },
        {
          title: '剂型', key: 'dosageFormName', minWidth: 116, tooltip: true,
        },
        {
          title: '原单位', key: 'originMinPkgUnitName', minWidth: 116, tooltip: true,
        },
        {
          title: '拆零单位', key: 'unpackMinPkgUnitName', minWidth: 116, tooltip: true,
        },
        {
          title: '生产日期', key: 'goodsProductionDate', minWidth: 116, tooltip: true,
        },
        {
          title: '批号', key: 'goodsBatchNumber', minWidth: 116, tooltip: true,
        },
        {
          title: '批次', key: 'goodsBatchSeq', minWidth: 116, tooltip: true,
        },
        {
          title: '有效期', key: 'goodsExpiryDate', minWidth: 116, tooltip: true,
        },
        {
          title: '生产厂家', key: 'producer', minWidth: 116, tooltip: true,
        },
        {
          title: '可售数量', key: 'goodsStockNum', minWidth: 116, tooltip: true,
        },
        {
          title: '操作人', key: 'createUserName', minWidth: 116, tooltip: true,
        },
        {
          title: '拆零时间', key: 'createTime', minWidth: 130, tooltip: true,

        },
      ],
      tableData: [],
    };
  },
  computed: {
    addText() {
      return (this.handlePermission('unpackInventoryQueryExport') ? '导出Excel' : '');
    },
  },
  methods: {
    handleExport() {
      const downloadParams = this.params;
      delete downloadParams.page;
      delete downloadParams.size;
      if (downloadParams.unpackTimeRange && downloadParams.unpackTimeRange.length === 2) {
        downloadParams.createTimeStart = downloadParams.unpackTimeRange[0];
        downloadParams.createTimeEnd = downloadParams.unpackTimeRange[1];
      }
      downloadParams.queryCondition = utils.getQueryCondition('.queryContainer');
      unpack.downloadUnpackInventory(downloadParams)
        .then((res) => {
          if (res.data.error) {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getData() {
      this.params.size = this.size;
      this.params.page = this.page;
      if (this.params.unpackTimeRange && this.params.unpackTimeRange.length === 2) {
        this.params.createTimeStart = this.params.unpackTimeRange[0];
        this.params.createTimeEnd = this.params.unpackTimeRange[1];
      }
      unpack.getUnpackInventoryList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          const { data } = res.data;
          this.count = data.count;
          data.list.forEach((item) => {
            const itemTemp = {};
            const {
              approvedDrugName,
              spec,
              producer,
              drugSerialCode,
              dosageFormName,
            } = item.goodsInfoVo;

            const {
              goodsBatchNumber,
              goodsBatchSeq,
              goodsStockNum,
              goodsProductionDate,
              goodsExpiryDate,
              emptyTime,
            } = item.unpackInventory;

            const {
              originMinPkgUnitName,
              unpackMinPkgUnitName,
              createUserName,
              storeName,
              createTime,
            } = item.inventoryUnpackRecord;

            Object.assign(itemTemp, {
              approvedDrugName,
              spec,
              producer,
              drugSerialCode,
              dosageFormName,
              goodsBatchNumber,
              goodsBatchSeq,
              goodsStockNum,
              goodsProductionDate: utils.exchangeTime(goodsProductionDate),
              goodsExpiryDate: utils.exchangeTime(goodsExpiryDate),
              emptyTime: utils.exchangeTime(emptyTime),
              originMinPkgUnitName,
              unpackMinPkgUnitName,
              createUserName,
              storeName,
              createTime: utils.exchangeTimeToSecond(createTime),
            });

            this.tableData.push(itemTemp);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        unpackTimeRange: [],
        hasGoods: null,
      };
    },
  },
  mounted() {
    if (this.roleType !== 2) {
      this.columns.splice(0, 0, {
        title: '门店', key: 'storeName', minWidth: 116, tooltip: true,
      });
    }
    this.query.hasGoods = 1;
    this.handleSearch(true);
  },
};
</script>
<style lang="less">
.unpackInventory-list {
  .search-btn {
    margin-right: 10px;
  }
}

</style>
